<router-outlet></router-outlet>
<div class="onModal toast  toast-success hide" role="alert" aria-live="assertive">
    <div class="toast-body">
        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Cerrar">
            <span aria-hidden="true">&times;</span>
        </button>
        <i class="fa-check fas"></i>&nbsp;Los cambios han sido efectuados con éxito.
    </div>
</div>
<div class="onModal toast toast-danger hide" role="alert" aria-live="assertive">
    <div class="toast-body">
        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Cerrar">
            <span aria-hidden="true">&times;</span>
        </button>
        <i class="fa-window-close fas"></i>&nbsp;Ha ocurrido un error, favor intente nuevamente.
    </div>
</div>

<div class="toast toast-success hide toast-success-custom-message" role="alert" aria-live="assertive">
    <div class="toast-body">
        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Cerrar">
            <span aria-hidden="true">&times;</span>
        </button>
        <i class="fa-check fas"></i>&nbsp;El formulario se guardó exitosamente.
    </div>
</div>

<ng-container *ngIf="!domainService.isComplaintChannelDomain()">

    <div class="btn-float-level-2"
        *ngIf="(userService.loggedIn() === false || userService.isEmployee() === true) && showButtonSalary === true">
        <a (click)="onClickWhastapp()" class="btn btn-custom-cta-whatsapp btn-lg ligth-box-shadow-10 anim-this"
            [href]="configService.getWhatsappCommunityUrl()" target="_blank" rel="nofollow"> <i
                class="pj-ico pj-ico-whatsapp"></i><span class="btn-text">Ofertas <span style="white-space: nowrap;">a
                    tu</span> WhatsApp</span></a>
    </div>

    <div class="btn-float-2" *ngIf="userService.loggedIn() === true && userService.isEmployer() === true">
        <a class="btn btn-custom-cta-support-status btn-lg ligth-box-shadow-10 anim-this"
            href="https://api.whatsapp.com/send/?phone=%2B56950912392" target="_blank" rel="nofollow">
            <div><i class="pj-ico pj-ico-whatsapp"></i>
            </div>
            <div class="main-ctn"><span class="btn-text">Soporte</span>
                <div class="status-ctn online" *ngIf="showbuttonSupportOnline">
                    <div class="now-status-icon"></div>
                    <span class="status-text">Online</span>
                </div>
            </div>
        </a>
    </div>

</ng-container>